import { useState, useEffect } from "react";
import axios from "axios";
import { logout } from "../../store/auth/auth-actions";
import { StyleSheet, css } from "aphrodite";
import { Link, useNavigate } from "react-router-dom";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import LogoutIcon from "@mui/icons-material/LogoutOutlined";
import Divider from "@mui/material/Divider";
import logoIvitech_colorido from "../../assets/imgs/logoivitech_colorido.png";
import ivitech_reduced from "../../assets/imgs/ivitech_reduced.png";
import "../../assets/styles/drawer.css";
import { headers } from "../core/store/localStorage";
import errorHandler from "../core/store/errorHandler";
import {
  AccountBalance,
  AccountBalanceWallet,
  Article,
  BusinessCenter,
  CreateNewFolder,
  EditDocument,
  LocalShipping,
  MoneyOff,
  PriceChange,
  PriceCheck,
  Search,
  Warehouse,
} from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { menuOptions } from "../../util/menus";

// const API_URL = sessionStorage.getItem("apiUrl");
// const userId = sessionStorage.getItem("userId");

const asyncsessionStorage = {
  async getItem(key: any) {
    await null;
    return sessionStorage.getItem(key);
  },
};

interface Props {
  open: boolean;
  openDialog: boolean;
  openQuerySubMenu: boolean;
  toggleDialog: () => void;
  toggleQueryMenu: () => void;
}

const DrawerItemsList: any = (props: Props) => {
  const [pages, setPages] = useState<any>("");
  const [API_URL, setCurrentAPI] = useState<any>("");
  const [userId, setCurrentUserID] = useState<any>("");

  useEffect(() => {
    getAPI();
    getUserID();

    if (
      API_URL === null ||
      userId === null ||
      API_URL === undefined ||
      userId === undefined
    ) {
      window.location.href = "/";
    }
  }, []);

  useEffect(() => {
    getUserAccess();
  }, [API_URL, userId]);

  const navigate = useNavigate();
  const { open, openDialog, openQuerySubMenu, toggleDialog, toggleQueryMenu } =
    props;

  const [openContasApagarSubMenu, setOpenContasApagarSubMenu] = useState(false);
  const [openContasApagarCadastroSubMenu, setOpenContasApagarCadastroSubMenu] =
    useState(false);

  const toggleContasApagarMenu = () => {
    setOpenContasApagarSubMenu(!openContasApagarSubMenu);
  };

  const toggleContasApagarCadastroMenu = () => {
    setOpenContasApagarCadastroSubMenu((v) => !v);
  };

  function getAPI() {
    asyncsessionStorage.getItem("apiUrl").then((response) => {
      setCurrentAPI(response);
    });
  }
  function getUserID() {
    asyncsessionStorage.getItem("userId").then((response) => {
      setCurrentUserID(response);
    });
  }

  async function getUserAccess() {
    await axios
      .get(`${API_URL}/user/${userId}/tela`, headers())
      .then((response) => {
        let resp: any = [];
        response.data.data.map((res: any) => {
          resp.push(res.name);
        });
        setPages(resp);
      })
      .catch((err) => {
        errorHandler(err);
      });
  }

  return (
    <>
      <div className={css(styles.drawerContainer)}>
        {open && (
          <Box sx={{ px: 2, py: 1 }}>
            <Autocomplete
              options={menuOptions}
              groupBy={(option) => option.category}
              getOptionLabel={(option) => option.label}
              ListboxProps={{
                style: {
                  maxHeight: "150px",
                },
              }}
              sx={{
                "& .MuiAutocomplete-listbox": {
                  padding: 0,
                  "& .MuiAutocomplete-option": {
                    minHeight: "40px",
                  },
                },
              }}
              onChange={(event, newValue) => {
                if (newValue) navigate(newValue.path);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Buscar tela"
                  variant="standard"
                  fullWidth
                  color="success"
                  InputProps={{
                    ...params.InputProps,
                    disableUnderline: false,
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search sx={{ fontSize: 18, color: "action.active" }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiInputBase-root": { fontSize: 13 },
                  }}
                />
              )}
              renderOption={(props, option) => {
                const { key, ...optionProps } = props as any;
                return (
                  <Box
                    component="li"
                    key={key}
                    {...optionProps}
                    sx={{
                      fontSize: 12,
                      height: "40px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="body2" sx={{ fontSize: 12 }}>
                      {option.label}
                    </Typography>
                  </Box>
                );
              }}
            />
          </Box>
        )}

        <List style={{ marginTop: "-0.5rem" }}>
          {/* CONTAS A PAGAR */}
          <ListItemButton
            onClick={toggleContasApagarMenu}
            sx={{
              minHeight: 15,
              justifyContent: open ? "initial" : "center",
              px: 2.5,
              py: 0.2,
            }}
            title={open ? "" : "Contas a Pagar"}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: open ? 1.4 : "auto",
                justifyContent: "center",
              }}
            >
              <AttachMoneyOutlinedIcon sx={{ fontSize: 18 }} />
            </ListItemIcon>
            <ListItemText
              primary={"Contas a Pagar"}
              sx={{ opacity: open ? 1 : 0 }}
              primaryTypographyProps={{ fontSize: 12 }}
            />
            {openContasApagarSubMenu ? (
              <ExpandLess style={{ width: 16 }} color="action" />
            ) : (
              <ExpandMore style={{ width: 16 }} color="action" />
            )}
          </ListItemButton>

          {openContasApagarSubMenu && <Divider />}

          <Collapse in={openContasApagarSubMenu} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton
                onClick={toggleContasApagarCadastroMenu}
                sx={{
                  minHeight: 15,
                  justifyContent: open ? "initial" : "center",
                  px: 3.5,
                  py: 0.2,
                }}
                title={open ? "" : "Cadastros"}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 1.5 : "auto",
                    ml: open ? "" : -0.2,
                    justifyContent: "center",
                  }}
                >
                  <CreateNewFolder sx={{ fontSize: 18 }} />
                </ListItemIcon>
                <ListItemText
                  primary={"Cadastros"}
                  sx={{ opacity: open ? 1 : 0 }}
                  primaryTypographyProps={{ fontSize: 12 }}
                />
                {openContasApagarCadastroSubMenu ? (
                  <ExpandLess style={{ width: 16 }} color="action" />
                ) : (
                  <ExpandMore style={{ width: 16 }} color="action" />
                )}
              </ListItemButton>

              <Collapse
                in={openContasApagarCadastroSubMenu}
                timeout="auto"
                unmountOnExit
              >
                <List component="div" disablePadding>
                  <Link
                    to={"/contas-a-pagar/agente-cobrador"}
                    className={css(styles.noDecoration)}
                  >
                    <ListItemButton
                      key={"cadAgenteCobrador"}
                      sx={{
                        minHeight: 15,
                        justifyContent: open ? "initial" : "center",
                        px: 4.5,
                        py: 0.2,
                      }}
                      title={open ? "" : "Agente Cobrador"}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 1.5 : "auto",
                          ml: open ? "" : -0.2,
                          justifyContent: "center",
                        }}
                      >
                        <AccountBalance sx={{ fontSize: 18 }} />
                      </ListItemIcon>
                      <ListItemText
                        primary={"Agente Cobrador"}
                        sx={{ opacity: open ? 1 : 0 }}
                        primaryTypographyProps={{ fontSize: 12 }}
                      />
                    </ListItemButton>
                  </Link>
                </List>

                <List component="div" disablePadding>
                  <Link
                    to={"/contas-a-pagar/centro-de-custo"}
                    className={css(styles.noDecoration)}
                  >
                    <ListItemButton
                      key={"cadCentroDeCusto"}
                      sx={{
                        minHeight: 15,
                        justifyContent: open ? "initial" : "center",
                        px: 4.5,
                        py: 0.2,
                      }}
                      title={open ? "" : "Centro de Custo"}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 1.5 : "auto",
                          ml: open ? "" : -0.2,
                          justifyContent: "center",
                        }}
                      >
                        <BusinessCenter sx={{ fontSize: 18 }} />
                      </ListItemIcon>
                      <ListItemText
                        primary={"Centro de Custo"}
                        sx={{ opacity: open ? 1 : 0 }}
                        primaryTypographyProps={{ fontSize: 12 }}
                      />
                    </ListItemButton>
                  </Link>
                </List>

                <List component="div" disablePadding>
                  <Link
                    to={"/contas-a-pagar/conta-corrente"}
                    className={css(styles.noDecoration)}
                  >
                    <ListItemButton
                      key={"cadContaCorrente"}
                      sx={{
                        minHeight: 15,
                        justifyContent: open ? "initial" : "center",
                        px: 4.5,
                        py: 0.2,
                      }}
                      title={open ? "" : "Conta Corrente"}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 1.5 : "auto",
                          ml: open ? "" : -0.2,
                          justifyContent: "center",
                        }}
                      >
                        <AccountBalanceWallet sx={{ fontSize: 18 }} />
                      </ListItemIcon>
                      <ListItemText
                        primary={"Conta Corrente"}
                        sx={{ opacity: open ? 1 : 0 }}
                        primaryTypographyProps={{ fontSize: 12 }}
                      />
                    </ListItemButton>
                  </Link>
                </List>

                <List component="div" disablePadding>
                  <Link
                    to={"/contas-a-pagar/despesa"}
                    className={css(styles.noDecoration)}
                  >
                    <ListItemButton
                      key={"cadDespesa"}
                      sx={{
                        minHeight: 15,
                        justifyContent: open ? "initial" : "center",
                        px: 4.5,
                        py: 0.2,
                      }}
                      title={open ? "" : "Despesa"}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 1.5 : "auto",
                          ml: open ? "" : -0.2,
                          justifyContent: "center",
                        }}
                      >
                        <MoneyOff sx={{ fontSize: 18 }} />
                      </ListItemIcon>
                      <ListItemText
                        primary={"Despesa"}
                        sx={{ opacity: open ? 1 : 0 }}
                        primaryTypographyProps={{ fontSize: 12 }}
                      />
                    </ListItemButton>
                  </Link>
                </List>

                <List component="div" disablePadding>
                  <Link
                    to={"/contas-a-pagar/estabelecimento"}
                    className={css(styles.noDecoration)}
                  >
                    <ListItemButton
                      key={"cadEstabelecimento"}
                      sx={{
                        minHeight: 15,
                        justifyContent: open ? "initial" : "center",
                        px: 4.5,
                        py: 0.2,
                      }}
                      title={open ? "" : "Estabelecimento"}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 1.5 : "auto",
                          ml: open ? "" : -0.2,
                          justifyContent: "center",
                        }}
                      >
                        <Warehouse sx={{ fontSize: 18 }} />
                      </ListItemIcon>
                      <ListItemText
                        primary={"Estabelecimento"}
                        sx={{ opacity: open ? 1 : 0 }}
                        primaryTypographyProps={{ fontSize: 12 }}
                      />
                    </ListItemButton>
                  </Link>
                </List>

                <List component="div" disablePadding>
                  <Link
                    to={"/contas-a-pagar/fornecedor"}
                    className={css(styles.noDecoration)}
                  >
                    <ListItemButton
                      key={"cadFornecedor"}
                      sx={{
                        minHeight: 15,
                        justifyContent: open ? "initial" : "center",
                        px: 4.5,
                        py: 0.2,
                      }}
                      title={open ? "" : "Fornecedores"}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 1.5 : "auto",
                          ml: open ? "" : -0.2,
                          justifyContent: "center",
                        }}
                      >
                        <LocalShipping sx={{ fontSize: 18 }} />
                      </ListItemIcon>
                      <ListItemText
                        primary={"Fornecedores"}
                        sx={{ opacity: open ? 1 : 0 }}
                        primaryTypographyProps={{ fontSize: 12 }}
                      />
                    </ListItemButton>
                  </Link>
                </List>

                <List component="div" disablePadding>
                  <Link
                    to={"/contas-a-pagar/plano-contas"}
                    className={css(styles.noDecoration)}
                  >
                    <ListItemButton
                      key={"planoContas"}
                      sx={{
                        minHeight: 15,
                        justifyContent: open ? "initial" : "center",
                        px: 4.5,
                        py: 0.2,
                      }}
                      title={open ? "" : "Plano de Contas"}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 1.5 : "auto",
                          ml: open ? "" : -0.2,
                          justifyContent: "center",
                        }}
                      >
                        <AccountBalanceWallet sx={{ fontSize: 18 }} />
                      </ListItemIcon>
                      <ListItemText
                        primary={"Plano de Contas"}
                        sx={{ opacity: open ? 1 : 0 }}
                        primaryTypographyProps={{ fontSize: 12 }}
                      />
                    </ListItemButton>
                  </Link>
                </List>

                <List component="div" disablePadding>
                  <Link
                    to={"/contas-a-pagar/tipo-de-documento"}
                    className={css(styles.noDecoration)}
                  >
                    <ListItemButton
                      key={"cadTipoDeDocumento"}
                      sx={{
                        minHeight: 15,
                        justifyContent: open ? "initial" : "center",
                        px: 4.5,
                        py: 0.2,
                      }}
                      title={open ? "" : "Tipo de Doc."}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 1.5 : "auto",
                          ml: open ? "" : -0.2,
                          justifyContent: "center",
                        }}
                      >
                        <EditDocument sx={{ fontSize: 18 }} />
                      </ListItemIcon>
                      <ListItemText
                        primary={"Tipo de Doc."}
                        sx={{ opacity: open ? 1 : 0 }}
                        primaryTypographyProps={{ fontSize: 12 }}
                      />
                    </ListItemButton>
                  </Link>

                  <List component="div" disablePadding>
                    <Link
                      to={"/contas-a-pagar/tipo-de-fornecedor"}
                      className={css(styles.noDecoration)}
                    >
                      <ListItemButton
                        key={"cadTipoDeFornecedor"}
                        sx={{
                          minHeight: 15,
                          justifyContent: open ? "initial" : "center",
                          px: 4.5,
                          py: 0.2,
                        }}
                        title={open ? "" : "Tipo de Fornec."}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 1.5 : "auto",
                            ml: open ? "" : -0.2,
                            justifyContent: "center",
                          }}
                        >
                          <Article sx={{ fontSize: 18 }} />
                        </ListItemIcon>
                        <ListItemText
                          primary={"Tipo de Fornec."}
                          sx={{ opacity: open ? 1 : 0 }}
                          primaryTypographyProps={{ fontSize: 12 }}
                        />
                      </ListItemButton>
                    </Link>
                  </List>

                  <List component="div" disablePadding>
                    <Link
                      to={"/contas-a-pagar/tipo-pagamento"}
                      className={css(styles.noDecoration)}
                    >
                      <ListItemButton
                        key={"cadTipoPagamento"}
                        sx={{
                          minHeight: 15,
                          justifyContent: open ? "initial" : "center",
                          px: 4.5,
                          py: 0.2,
                        }}
                        title={open ? "" : "Tipo de Pag."}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 1.5 : "auto",
                            ml: open ? "" : -0.2,
                            justifyContent: "center",
                          }}
                        >
                          <PriceChange sx={{ fontSize: 18 }} />
                        </ListItemIcon>
                        <ListItemText
                          primary={"Tipo de Pag."}
                          sx={{ opacity: open ? 1 : 0 }}
                          primaryTypographyProps={{ fontSize: 12 }}
                        />
                      </ListItemButton>
                    </Link>
                  </List>
                </List>

                <Divider />
              </Collapse>

              <Link
                to={"/contas-a-pagar/lancamento"}
                className={css(styles.noDecoration)}
              >
                <ListItemButton
                  key={"lancamento"}
                  sx={{
                    minHeight: 15,
                    justifyContent: open ? "initial" : "center",
                    px: 3.5,
                    py: 0.2,
                  }}
                  title={open ? "" : "Lançamentos"}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 1.5 : "auto",
                      ml: open ? "" : -0.2,
                      justifyContent: "center",
                    }}
                  >
                    <PriceCheck sx={{ fontSize: 18 }} />
                  </ListItemIcon>
                  <ListItemText
                    primary={"Lançamentos"}
                    sx={{ opacity: open ? 1 : 0 }}
                    primaryTypographyProps={{ fontSize: 12 }}
                  />
                </ListItemButton>
              </Link>

              <Link
                to={"/contas-a-pagar/consulta"}
                className={css(styles.noDecoration)}
              >
                <ListItemButton
                  key={"consulta"}
                  sx={{
                    minHeight: 15,
                    justifyContent: open ? "initial" : "center",
                    px: 3.5,
                    py: 0.2,
                  }}
                  title={open ? "" : "Consulta"}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 1.5 : "auto",
                      ml: open ? "" : -0.2,
                      justifyContent: "center",
                    }}
                  >
                    <Search sx={{ fontSize: 18 }} />
                  </ListItemIcon>
                  <ListItemText
                    primary={"Consulta"}
                    sx={{ opacity: open ? 1 : 0 }}
                    primaryTypographyProps={{ fontSize: 12 }}
                  />
                </ListItemButton>
              </Link>
            </List>

            <Divider />
          </Collapse>

          <Divider />

          <ListItemButton
            key={"Sair"}
            sx={{
              minHeight: 15,
              justifyContent: open ? "initial" : "center",
              px: 2.5,
              py: 0.2,
            }}
            title={open ? "" : "Sair"}
            onClick={toggleDialog}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: open ? 1.4 : "auto",
                ml: open ? 0.2 : "",
                justifyContent: "center",
              }}
            >
              <LogoutIcon sx={{ fontSize: 18 }} />
            </ListItemIcon>
            <ListItemText
              primary={"Sair"}
              sx={{ opacity: open ? 1 : 0 }}
              primaryTypographyProps={{ fontSize: 12 }}
            />
          </ListItemButton>
        </List>

        {/* logo... mantém do jeito que está */}
        <div className={css(styles.logoContainer)}>
          <Link
            to={"https://ivitech.com.br"}
            target="_blank"
            style={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "3rem",
            }}
          >
            <img
              src={logoIvitech_colorido}
              style={{
                width: "6.5rem",
                opacity: open ? 1 : 0,
                transition: "opacity 0.3s ease, transform 0.3s ease",
                transform: open ? "scale(1)" : "scale(0.8)",
                position: open ? "relative" : "absolute",
                visibility: open ? "visible" : "hidden",
              }}
              alt=""
            />

            <img
              src={ivitech_reduced}
              style={{
                width: "2.5rem",
                opacity: open ? 0 : 1,
                transition: "opacity 0.3s ease, transform 0.3s ease",
                transform: open ? "scale(1.2)" : "scale(1)",
                position: open ? "absolute" : "relative",
                visibility: open ? "hidden" : "visible",
              }}
              alt=""
            />
          </Link>
        </div>
      </div>
    </>
  );
};

const styles = StyleSheet.create({
  noDecoration: {
    textDecoration: "none",
    color: "inherit",
  },
  drawerContainer: {
    height: "100vh",
    transition: "width 0.3s ease",
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
    overflowX: "hidden",
    "::-webkit-scrollbar": {
      width: "8px",
    },
    "::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "4px",
    },
    "::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
  },
  logoContainer: {
    padding: "12px",
    textAlign: "center",
    marginTop: "auto", // Ainda mantém no final, mas sem position fixed
  },
});

export default DrawerItemsList;
